import Vue from 'vue'
import Router from 'vue-router'

const both = (name) => () => import(`@/views/${name}`);
Vue.use(Router)
var routes=[
	{
		path: '/login',
		name: 'login',
		component: both("login"),
	},
	{
		path: '/NotFound',
		name: 'NotFound',
		component: both("NotFound"),
	},
	{
		path: '/',
		name: '',
		component: both("Home"),
		children: [
			{
				path: 'index',
				component: both("index"),
				name: '首页'
			},
			{
				path: 'system_menu',
				component: both("system/menu"),
				name: '系统设置'
			},
			{
				path: 'operate_dictionary',
				component: both("operate/dictionary"),
				name: '数据字典'
			},
			{
				path: 'operate_dictionary_list',
				component: both("operate/dictionary_list"),
				name: '数据字典列表'
			},
			{
				path: 'operate_store',
				component: both("operate/store"),
				name: '门店管理'
			},
			{
				path: 'operate_department',
				component: both("operate/department"),
				name: '部门管理'
			},
			{
				path: 'operate_role',
				component: both("operate/role"),
				name: '角色管理'
			},
			{
				path: 'operate_staff',
				component: both("operate/staff"),
				name: '员工管理'
			},
			{
				path: 'operate_supplier',
				component: both("operate/supplier"),
				name: '供应商管理'
			},
			{
				path: 'operate_integral',
				component: both("operate/integral"),
				name: '积分管理'
			},
			{
				path: 'goods_sort',
				component: both("goods/sort"),
				name: '分类信息'
			},
			{
				path: 'goods_index',
				component: both("goods/index"),
				name: '商品信息'
			},
			{
				path: 'order_index',
				component: both("order/index"),
				name: '订单列表'
			},
			{
				path: 'order_info',
				component: both("order/info"),
				name: '订单详情'
			},
			{
				path: 'order_return_goods',
				component: both("order/return_goods"),
				name: '核销退货'
			},
			{
				path: 'order_retreat',
				component: both("order/retreat"),
				name: '退货'
			},
			{
				path: 'order_sale',
				component: both("order/sale"),
				name: '销售录单'
			},
			{
				path: 'order_gift',
				component: both("order/gift"),
				name: '礼品录单'
			},
			{
				path: 'member_level',
				component: both("member/level"),
				name: '会员等级'
			},
			{
				path: 'member_add',
				component: both("member/add"),
				name: '新建会员'
			},
			{
				path: 'member_index',
				component: both("member/index"),
				name: '会员列表'
			},
			{
				path: 'member_info',
				component: both("member/info"),
				name: '会员详情'
			},
			{
				path: 'activity_index',
				component: both("activity/index"),
				name: '活动列表'
			},
			{
				path: 'activity_goods',
				component: both("activity/goods"),
				name: '活动商品'
			},
			{
				path: 'activity_member',
				component: both("activity/member"),
				name: '活动会员'
			},
			{
				path: 'form_business_sales',
				component: both("form/business_sales"),
				name: '业务销售报表'
			},
			{
				path: 'form_customer',
				component: both("form/customer"),
				name: '客户购买报表'
			},
			{
				path: 'form_store',
				component: both("form/store"),
				name: '门店营业报表'
			},
			{
				path: 'form_city',
				component: both("form/city"),
				name: '城市营业报表'
			},
			{
				path: 'form_single_product',
				component: both("form/single_product"),
				name: '单品销售报表'
			},
			{
				path: 'form_sale',
				component: both("form/sale"),
				name: '销售清单'
			},
			{
				path: 'form_ranking',
				component: both("form/ranking"),
				name: '销售排行'
			},
			{
				path: 'stock_warehousing',
				component: both("stock/warehousing"),
				name: '入库管理'
			},
			{
				path: 'stock_inventory',
				component: both("stock/inventory"),
				name: '库存预警'
			},
			{
				path: 'stock_out',
				component: both("stock/out"),
				name: '出库管理'
			},
			{
				path: 'stock_warehouse',
				component: both("stock/warehouse"),
				name: '库房管理'
			},
			{
				path: 'stock_order',
				component: both("stock/order"),
				name: '配送订单'
			},
			{
				path: 'stock_month',
				component: both("stock/month"),
				name: '月结管理'
			},
			{
				path: 'message_index',
				component: both("message/index"),
				name: '消息管理'
			},
			{
				path: 'message_deposit_list',
				component: both("message/deposit_list"),
				name: '寄存数据列表'
			},
			{
				path: 'stock_logistics',
				component: both("stock/logistics"),
				name: '物流录单'
			},
			{
				path: 'stock_logistics_info',
				component: both("stock/logistics_info"),
				name: '物流录单-详情'
			},
			{
				path: 'video_index',
				component: both("video/index"),
				name: '视频管理'
			},
			{
				path: 'video_report',
				component: both("video/report"),
				name: '视频统计'
			},
		],
	},
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js